export default __webpack_public_path__ + "static/media/customized0.4acc840c.png";